module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Sitemap"
  }, [_c('h1', [_vm._v("Site Directory")]), _c('ul', {
    attrs: {
      "id": "mainmenu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "first"
    }
  }, [_vm._v("Office Info"), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-the-doctors",
      "onclick": "active1()"
    }
  }, [_vm._v("Meet the Doctors")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/meet-our-staff",
      "onclick": "active1()"
    }
  }, [_vm._v("Meet Our Staff")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/office-policies-and-mission",
      "onclick": "active1()"
    }
  }, [_vm._v("Office Policies and Mission")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/map-and-directions",
      "onclick": "active1()"
    }
  }, [_vm._v("Map and Directions")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/financial-and-insurance",
      "onclick": "active1()"
    }
  }, [_vm._v("Financial and Insurance")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-testimonials",
      "onclick": "active1()"
    }
  }, [_vm._v("Patient Testimonials")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/office-tour-and-photo-gallery",
      "onclick": "active1()"
    }
  }, [_vm._v("Office Tour and Photo Gallery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/refer-our-office",
      "onclick": "active1()"
    }
  }, [_vm._v("Refer Our Office")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/practice-events",
      "onclick": "active1()"
    }
  }, [_vm._v("Practice Events")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/appointment-request",
      "onclick": "active1()"
    }
  }, [_vm._v("Appointment Request")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/our-beaumont-tx-office",
      "onclick": "active1()"
    }
  }, [_vm._v("Our Beaumont TX Office")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "two"
    }
  }, [_vm._v("Patient Info"), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/why-choose-us",
      "onclick": "active2()"
    }
  }, [_vm._v("Why Choose Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/first-visit",
      "onclick": "active2()"
    }
  }, [_vm._v("First Visit")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/faq",
      "onclick": "active2()"
    }
  }, [_vm._v("FAQ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/before-and-after-photos",
      "onclick": "active2()"
    }
  }, [_vm._v("Before and After Photos")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/brushing-and-flossing",
      "onclick": "active2()"
    }
  }, [_vm._v("Brushing and Flossing")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/common-problems",
      "onclick": "active2()"
    }
  }, [_vm._v("Common Problems")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/emergency-info",
      "onclick": "active2()"
    }
  }, [_vm._v("Emergency Info")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/foods-to-avoid",
      "onclick": "active2()"
    }
  }, [_vm._v("Foods to Avoid")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "",
      "id": "three"
    }
  }, [_vm._v("Treatment Info  "), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/early-treatment",
      "onclick": "active3()"
    }
  }, [_vm._v("Early Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/phase-ii-adolescent-treatment",
      "onclick": "active3()"
    }
  }, [_vm._v("Phase II / Adolescent Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/adult-treatment",
      "onclick": "active3()"
    }
  }, [_vm._v("Adult Treatment")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/types-of-braces",
      "onclick": "active3()"
    }
  }, [_vm._v("Types of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/invisalign",
      "onclick": "active3()"
    }
  }, [_vm._v("Invisalign")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/retention",
      "onclick": "active3()"
    }
  }, [_vm._v("Retention")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/jaw-surgery",
      "onclick": "active3()"
    }
  }, [_vm._v("Jaw Surgery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tmj",
      "onclick": "active3()"
    }
  }, [_vm._v("TMJ       ")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/palatal-expander",
      "onclick": "active3()"
    }
  }, [_vm._v("Palatal Expander         ")])], 1)])])], 1), _c('li', {
    staticClass: "funtabbar"
  }, [_c('router-link', {
    attrs: {
      "to": "",
      "id": "four"
    }
  }, [_vm._v("Fun Stuff"), _c('ul', {
    staticClass: "submenu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/games",
      "onclick": "active4()"
    }
  }, [_vm._v("Games")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/band-color-chooser",
      "onclick": "active4()"
    }
  }, [_vm._v("Band Color Chooser")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/related-links",
      "onclick": "active4()"
    }
  }, [_vm._v("Related Links")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/patient-gallery",
      "onclick": "active4()"
    }
  }, [_vm._v("Patient Gallery")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/glossary",
      "onclick": "active4()"
    }
  }, [_vm._v("Glossary")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/parts-of-braces",
      "onclick": "active4()"
    }
  }, [_vm._v("Parts of Braces")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/feedback",
      "onclick": "active4()"
    }
  }, [_vm._v("Feedback")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/blog",
      "onclick": "active4()"
    }
  }, [_vm._v("Blog ")])], 1)])])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact-us"
    }
  }, [_vm._v("Contact Us")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/site-directory"
    }
  }, [_vm._v("Site Map")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/privacy-policy"
    }
  }, [_vm._v("Privacy Policy           ")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-041208c8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/sitemap/sitemap.pug
// module id = 568
// module chunks = 1